'use client';

import { History } from '@repo/types';
import { FieldResolver } from '@repo/ui/lib/utils/field-label-resolver';
import { Circle } from 'lucide-react';

interface TravauxTroncProps {
  history: History;
  resolver: FieldResolver;
}

export function TravauxTronc({ history, resolver }: TravauxTroncProps) {
  const getTroncItems = (): string[] => {
    const items: string[] = [];

    // Resolve travaux_tronc_multiple if present
    if (history.travaux_tronc_multiple && Array.isArray(history.travaux_tronc_multiple) && history.travaux_tronc_multiple.length > 0) {
      const resolved = resolver.getFieldLabel('travaux_tronc_multiple')?.replace('other', '');
      if (resolved) {
        // Split by comma and add each item
        const splitItems = resolved.split(',').map(item => item.trim()).filter(Boolean);
        items.push(...splitItems);
      }
    } else if (history.travaux_tronc) {
      const resolved = resolver.getFieldLabel('travaux_tronc');
      if (resolved) {
        const splitItems = resolved.split(',').map(item => item.trim()).filter(Boolean);
        items.push(...splitItems);
      }
    }

    // Add other travaux if present
    if (history.travaux_tronc_other) {
      items.push(history.travaux_tronc_other);
    }

    // Add protection if present
    if (history.travaux_tronc_protection) {
      items.push(history.travaux_tronc_protection);
    }

    return items.length > 0 ? items : ['Aucun défaut apparent'];
  };

  const items = getTroncItems();
  const hasData = items.length > 0 && items[0] !== 'Aucun défaut apparent';

  return (
    <div className="space-y-2">
      <label className="text-sm font-medium text-gray-700 flex items-center gap-2">
        <Circle className="h-3 w-3 text-primary fill-current" />
        Tronc
      </label>
      <div className={`bg-gray-50 border rounded-lg px-4 py-3 min-h-[2.5rem] transition-all duration-200 ${hasData ? 'border-gray-200 hover:border-gray-300 hover:bg-gray-100/50' : 'border-gray-100'
        }`}>
        <div className="flex flex-col space-y-1.5">
          {items.map((item, index) => (
            <div key={index} className="flex items-start gap-2">
              <div className="w-1.5 h-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0"></div>
              <span className={`text-sm ${!hasData ? 'text-muted-foreground italic' : 'text-gray-900'}`}>
                {item}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
